import { Icon } from '@/shared/ui/icon'
import { useStyles } from './styles'
import { $farcanaGigiBalance, $userLanguage, $userToken, authUserFx } from '@/entities/user'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
import { BackgroundShading } from '@/shared/ui/backgroundShading'
import { ProfileCard } from '@/features/unifiedProfileCard'
import { Statistics } from '@/shared/ui/dataWrappers/farcanaStatistics'
import { AppButton } from '@/shared/ui/button'
import { useEffect, useState } from 'react'
import { getFarcanaStatsFx } from '@/entities/integration/model/effects'
import WebApp from '@twa-dev/sdk'
import { getUserProfileFx } from '@/entities/user'
import { $farcanaStatistics } from '@/entities/integration/model/store'
import { formatFarcanaStats, FormattedFarcanaStats } from '@/shared/util/formatFarcanaStats'
import { useHideNav } from '@/shared/hooks/useHideNav'
import { goToMain } from '@/app/routing/events'
import { useBackButton } from '@/shared/hooks/useBackButton'
import ButtonWrapper from '@/shared/ui/buttonWrapper'
import AppLoading from '@/features/loading'
// import { getRandomNumber } from '@/shared/util/getRandomNumber'

export const FarcanaProfileView = () => {
  useHideNav()
  useBackButton({})

  const userLang = useUnit($userLanguage)
  const userToken = useUnit($userToken)
  const statistics = useUnit($farcanaStatistics)

  const texts = lang[userLang].pages.farcanaProfile
  const btnTexts = lang[userLang].pages.btnTexts
  const farcanaGigi = useUnit($farcanaGigiBalance)

  const { classes } = useStyles()
  const [farcanaStats, setFarcanaStats] = useState<FormattedFarcanaStats[] | null>(null)
  useEffect(() => {
    if (userToken && statistics) {
      const formattedStats = formatFarcanaStats(statistics, userLang)
      setFarcanaStats(formattedStats)
    }
  }, [userToken, statistics, userLang])

  useEffect(() => {
    if (!userToken) {
      authUserFx({ init_data: WebApp.initData })
    } else {
      if (!statistics) {
        getFarcanaStatsFx(userToken)
        getUserProfileFx(userToken)
      }
    }
  }, [userToken, statistics])

  if (!statistics) return <AppLoading />

  return (
    <div className={classes.root}>
      <div className={classes.bannerContainer}>
        <Icon
          view="farcana"
          style={{ width: '50%', position: 'absolute', top: '25%', left: '25%', zIndex: 2 }}
        />
        <span className={classes.connectedText}>{texts.connectedSuccessfully}</span>
        <BackgroundShading
          bottom="0px"
          height="240px"
          background={'linear-gradient(0deg, #1D1E22 0%, rgba(29, 30, 34, 0.60) 52%, rgba(29, 30, 34, 0.00) 100%)'}
          zIndex={1}
        />
      </div>
      <div className={classes.contentWrapper}>
        <ProfileCard
          balance={farcanaGigi}
          username={statistics.nickname ?? ''}
        />
        <div className={classes.statsList}>
          {farcanaStats &&
            farcanaStats.map((stat) => (
              <Statistics
                key={stat.name}
                value={stat.value}
                // difference={getRandomNumber()}
                name={stat.name}
              />
            ))}
        </div>
      </div>
      <ButtonWrapper
        startColor="#00000000"
        endColor="#FFFFFF15"
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'center',
          padding: '0 12px',
        }}
      >
        <AppButton
          fullWidth
          onClick={() => goToMain()}
          className={classes.button}
        >
          {btnTexts.time}
        </AppButton>
      </ButtonWrapper>
    </div>
  )
}
